








/* General */
import Vue, { VueConstructor } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */
import ProfileAPI from '@/api/modules/profile.api'

const gapi = (window as any).gapi

export interface IBrowser {
  name: string
  version: string
}

export interface IGConfig {
  developerKey: string
  clientId: string
  appId: string
}

export default (Vue as VueConstructor<Vue & IGConfig>).extend({
  name: 'GooglePicker',

  data() {
    return {
      email: '',
      oauthToken: '',
      picker: {} as google.picker.Picker,
      pickerLoading: false,
      pickerApiLoaded: false,
      pickerIsVisible: false,
      browser: this.$deviceInfo.getBrowser as IBrowser,
    }
  },
  computed: {
    gConfig(): IGConfig {
      return {
        // The Browser API key obtained from the Google API Console.
        developerKey: `${process.env.VUE_APP_GOOGLE_API_DEV_KEY}`,
        // The Client ID obtained from the Google API Console. Replace with your own Client ID.
        clientId: `${process.env.VUE_APP_GOOGLE_API_CLIENT_ID}`,
        // Project number
        appId: `${process.env.VUE_APP_GOOGLE_APP_ID}`,
      }
    },
  },

  watch: {
    /**
     * Function to keep track of visibility status of picker
     */
    picker() {
      this.pickerIsVisible = this.picker.isVisible()
      if (this.pickerIsVisible) {
        this.addCustomButton()
      }
    },
  },

  methods: {
    async handleButtonClick() {
      this.initiGooglePicker()

      const appURL = `${process.env.VUE_APP_URL}/`
      const fromURL = `${appURL}${this.$route.params.accountId}/googledriveauth`
      const response = await ProfileAPI.get_GoogleDriveAuth(fromURL)

      /* Requires auth... */
      if (response.url) {
        let newWindow = null
        /**
         * Safari blocks pop-up windows and it doens't clearly , this way we can
         * overwrite this default behaviour
         */
        if (this.browser.name === 'Safari') {
          newWindow = window.open()
          newWindow.location.href = response.url
          newWindow.name = 'DoneDone - Google Authentication'
        } else {
          newWindow = window.open(
            response.url,
            'DoneDone - Google Authentication',
            'height=775,width=450',
          )
        }
        if (window.focus && newWindow) {
          newWindow.focus()
        }
      } else if (response.access_token) {
        /* Access token already exists */
        this.oauthToken = response.access_token
        response.email ? (this.email = response.email) : (this.email = '')

        if (this.pickerLoading) {
          return
        }
        this.pickerLoading = true

        this.createPicker()

        this.pickerLoading = false
      } else {
        this.$messaging.showGenericError()
      }
    },

    /**
     * Initialize google's api and added event to expect
     * storage event
     */
    initiGooglePicker() {
      if (!gapi) {
        return console.warn('Google API not loaded')
      }
      gapi.load('auth2')
      gapi.load('picker', () => {
        this.pickerApiLoaded = true
      })

      window.onstorage = (e: StorageEvent) => {
        if (e.key === 'googleAuth') {
          const newGoogleAuth = JSON.parse(e.newValue)
          if (newGoogleAuth.apiAuthToken && newGoogleAuth.email) {
            this.oauthToken = newGoogleAuth.apiAuthToken
            this.email = newGoogleAuth.email

            this.createPicker()
          } else {
            const message = newGoogleAuth.gerror
              ? newGoogleAuth.gerror
              : this.$strings.GENERIC_ERROR_MESSAGE
            this.$messaging.showError(message)
          }
        }
      }
    },

    /**
     * Create Google Picker
     */
    createPicker() {
      if (this.pickerApiLoaded && this.oauthToken) {
        const view = new google.picker.DocsView()
        view.setMode(google.picker.DocsViewMode.LIST)

        this.picker = new google.picker.PickerBuilder()
          .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
          .setAppId(this.appId)
          .setOAuthToken(this.oauthToken)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setDeveloperKey(this.gConfig.developerKey)
          .setCallback(this.pickerCallback)
          .build()
        this.picker.setVisible(true)
      }
    },

    /**
     * Add signout button
     */
    addCustomButton() {
      const pickers = document.querySelectorAll('.picker-dialog')
      if (pickers) {
        const button = document.createElement('div')
        button.className = 'google-drive-file-picker-signout-wrapper'
        button.innerHTML = `
          <p class="google-drive-file-picker-signout-wrapper__text">You’re signed into Google as ${
            this.email
          }</p>
          <button
            style="width:100%; padding-right: 0;"
            class="google-drive-file-picker-signout-wrapper__link"
          >Sign out</button>
        `

        // Add signout event handler
        button
          .querySelector('.google-drive-file-picker-signout-wrapper__link')
          .addEventListener('click', this.signoutFromGoogleDrive)

        // Find the last picker element because Google Drive picker creates
        // one element per click
        const currentPicker = pickers[pickers.length - 1] as HTMLElement

        currentPicker.appendChild(button)
      }
    },

    /**
     * Handle picked file
     */
    pickerCallback(data: any) {
      if (data[google.picker.Response.ACTION] === google.picker.Action.PICKED) {
        this.$emit('picked', data[google.picker.Response.DOCUMENTS])
        this.pickerIsVisible = false
        this.pickerLoading = false
      } else if (
        data[google.picker.Response.ACTION] === google.picker.Action.CANCEL
      ) {
        this.pickerIsVisible = false
        this.pickerLoading = false
      }
    },

    /**
     * Clear all data on signout
     */
    async clearAuth() {
      this.picker.setVisible(false)
      this.pickerIsVisible = false
      this.pickerLoading = false
      this.email = ''
      this.oauthToken = ''
    },

    /**
     * Function to signout
     */
    async signoutFromGoogleDrive() {
      await ProfileAPI.delete_RevokeGoogleDriveAuth()
      this.clearAuth()
    },
  },
})
